import { API, getAsyncThunk } from '../../api';

export const getFreebets = getAsyncThunk(
  'ACCOUNT:GET_FREEBETS',
  API.freebets.getFreebets,
);

export const getClientInfo = getAsyncThunk(
  'ACCOUNT:GET_CLIENT_INFO',
  API.client.clientInfo.getClientInfo,
);
